'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _tslib = require('./_tslib-15827112.js');
var request = _interopDefault(require('axios'));

var LoginConsent = /** @class */ (function () {
    function LoginConsent(_a) {
        var _this = this;
        var props = _tslib.__rest(_a, []);
        this.sendConsentStat = function () {
            var _a = _this.props, StatsData = _a.StatsData, getCookie = _a.getCookie, Texts = _a.Texts, INTERNAL_API_URL = _a.INTERNAL_API_URL;
            return request.post(INTERNAL_API_URL + "/Login/StatConsent", {
                userToken: getCookie('EndUserId'),
                complianceText: Texts.LOGIN_DESCRIPTION + " " + Texts.LOGIN_FINE_PRINT,
                city: StatsData.City,
                search: StatsData.Search,
                integration: StatsData.Provider,
                platform: StatsData.Platform
            });
        };
        this.props = props;
    }
    return LoginConsent;
}());

exports.default = LoginConsent;
//# sourceMappingURL=LoginConsent.js.map
